<template>
    <div>
        <h2>Input Observasi Peserta</h2>
        <a-form-model :model="formData" :rules="rules" ref="ruleForm">
            <a-skeleton :loading="preload" active>
                <a-descriptions bordered>
                    <a-descriptions-item label="Tanggal" span="3">
                        <a-date-picker @change="onDateChange" :format="'YYYY-MM-DD'" v-model="formData.date" type="date" />
                    </a-descriptions-item>
                    <a-descriptions-item label="Observasi" span="3">
                        <a-textarea v-model="formData.description" :rows="4" />
                    </a-descriptions-item>
                </a-descriptions>
                <div class="text-right" style="margin-top:24px;">
                    <a-button type="primary" html-type="submit" :loading="processing" :disabled="processing" @click="handleSubmit">Submit</a-button>
                </div>
            </a-skeleton>
        </a-form-model>
    </div>
</template>

<script>
export default {
    props: {
        layout: {
            type: Object,
            default: function() {
                return {
                    label: 6,
                    wrapper: 16
                };
            }
        },
        user_hash: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            formLayout: 'horizontal',
            form: this.$form.createForm(this),
            preload: false,
            processing: false,
            item: {},
            formData: {},
            rules: {
                date: [{ required: true, message: 'Tanggal harus diisi', trigger: 'change' }],
                description: [{ required: true, message: 'Observasi harus diisi', trigger: 'blur' }],
            }
        };
    },
    methods: {
        handleSubmit(e) {
            e.preventDefault(e)

            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.processing = true

                    let promise

                    var data = new FormData()

                    for (var k in this.formData) {
                        if (this.formData.hasOwnProperty(k)) {
                            data.append(k, this.formData[k])
                        }
                    }
                    data.append('attendant_id', this.user_hash)
                    promise = this.$http.post(
                        this.routeUri('api.performance.observation.store'),data
                    )

                    promise
                        .then(response =>
                            this.handleSuccessResponse(response.data)
                        )
                        .catch(error =>
                            this.handleResponseError(error.response.data)
                        )
                        .finally(() => (this.processing = false))
                }else{
                    return false
                }
            })
        },
        handleSuccessResponse(data) {
            var successMessage = "Data berhasil diproses!"

            if (typeof data.successMessage != "undefined") {
                successMessage = data.successMessage;
            }

            this.$notification.success({
                message: "Sukses!",
                description: successMessage
            });
            setTimeout(() => this.$emit("handleClose", true), 2000)
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    });
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                });
            }
        },
        handleClose() {
            this.$emit("handleClose", false)
        },
        onDateChange(date, dateString) {
            this.formData.observation_date = dateString
        },
    },
    watch:{
        formData: function(value) {
            if(value.hash != null){
                this.formData.date = value.observation_date
            }
        }
    }
}
</script>
